























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VueSeamlessStore from '@seamless/vue-store-plugin';
import { SeamlessCoreStore } from '@seamless/store';
import { Logger, TENANT } from '@b2x/common';

import { Link, UserMenuConfig } from '@/common/interfaces/common';
import LinkList from '@/components/link-list.vue';
import UserAlert from '@/components/user-alert.vue';
import {
  AuthenticationDispatchers,
  CiasClaims,
  IdentityProvider,
  AUTHENTICATION_CONNECTION,
  dispatchTracking,
  Alert,
} from '@b2x/authentication-library';

@Component({
  name: 'user-flyout',
  mixins: [new VueSeamlessStore().mixin],
  components: {
    LinkList,
    UserAlert,
  },
})
export default class UserFlyout extends Vue {
  store!: SeamlessCoreStore;

  @Prop()
  config!: UserMenuConfig;

  @Prop()
  claims!: CiasClaims;

  @Prop({
    default: null,
  })
  alert!: Alert | null;

  logger = new Logger('USER_MENU_FLYOUT');

  authDispatchers!: AuthenticationDispatchers;

  tenantId = location.hostname.includes('localhost') ? TENANT.CIAS : TENANT.ONEWEB;

  get overviewEntries(): Link[] {
    return this.config?.overviewEntriesPrivate;
  }

  get menuEntries(): Link[] {
    return this.config?.menuEntriesPrivate;
  }

  get settingsEntries(): Link[] {
    return this.config?.settingsEntriesPrivate;
  }

  async created(): Promise<void> {
    this.logger.log('user flyout created');

    this.authDispatchers = await this.store.getConnectionDispatchers(AUTHENTICATION_CONNECTION);
  }

  onLoginAction(): void {
    this.logger.log('Login action triggered');

    dispatchTracking({
      type: 'UM',
      label: 'login',
    });

    this.authDispatchers.login({ identityProvider: IdentityProvider.CIAS, tenantId: this.tenantId });
  }

  onLogoutAction(): void {
    this.logger.log('Logout action triggered');

    dispatchTracking({
      type: 'UM',
      label: 'logout',
    });

    this.authDispatchers.logout();
  }

  onRegisterAction(): void {
    dispatchTracking({
      type: 'UM',
      label: 'register',
    });

    this.logger.log('Register action triggered');

    // https://germany.pprod.publish.oneweb.mercedes-benz.com/bin/daimler/public/ciam/registration.html?lang=de_DE
    const redirectUrl = `${window.location.origin}/bin/daimler/public/ciam/registration.html`;
    this.authDispatchers.register({ redirectUrl });
  }

  onAlertDismiss(): void {
    this.authDispatchers.removeAlert();
  }
}
